import { call, put, takeLatest } from 'redux-saga/effects';
import {updateProduct} from "../../../services/product/product-service";
import {UPDATE_PRODUCT_REQUEST, updateProductFailure, updateProductSuccess} from "../actions/update-product-actions";

function* handleUpdateProduct(action) {
    try {
        const { id, formData } = action.payload;
        const result = yield call(updateProduct, id, formData);
        yield put(updateProductSuccess(result));
    } catch (error) {
        yield put(updateProductFailure(error));
    }
}

export function* watchUpdateProductSaga() {
    yield takeLatest(UPDATE_PRODUCT_REQUEST, handleUpdateProduct);
}
